var $ = require('jquery');
require('fg-frontend/edeeshop/jquery.product-list-filter');
require('fg-frontend/edeeshop/jquery.product-variant-select');
require('fg-frontend/edeeshop/jquery.edeeshop-photogallery');
require('fg-frontend/edeeshop/jquery.best-selled-products-toggle');
require('fg-frontend/edeeshop/jquery.fulltextAutocomplete');
require('fg-frontend/plugins/jquery.dhtmlnumber');
require('fg-frontend/plugins/jquery.universal-pagination');
require('bootstrap-slider');
require('fg-frontend/plugins/jquery.simple-collapse');
require('fg-frontend/ramjet/partialUpdate');

/**
 * USED EVENTS
 *
 * EDEESHOP_PRODUCTLIST_ITEMS_CHANGED - vystřelováno z jquery.product-list-filter.js
 * EDEESHOP_PRODUCTDETAIL_VARIANT_CHANGED - vystřelováno z jquery.product-variant-select.js
 * EDEESHOP_PRODUCT_PAGINATION_ACTIVATE - používáno v detailu kategorie (product list), znovuaktivace stránkování po zafiltrování (EDEESHOP_PRODUCTLIST_ITEMS_CHANGED)
 * EDEESHOP_BOOTSTRAP_SLIDER_ACTIVATE - používáno v detailu kategorie (product list), znovuaktivace bootstrap slideru po zafiltrování (EDEESHOP_PRODUCTLIST_ITEMS_CHANGED)
 * EDEESHOP_PHOTOGALLERY_ACTIVATE - používáno v detailu produktu po změně varianty (EDEESHOP_PRODUCTDETAIL_VARIANT_CHANGED)
 * EDEESHOP_PRODUCT_MODEL3D_ACTIVATE - start 3D modelu
 *
 */

import 'typeahead.js/dist/typeahead.jquery';
import Bloodhound from 'typeahead.js/dist/bloodhound';

window.Bloodhound = Bloodhound;

/**
 * simple collapse inicializace - 1 listener na body, ovládá všechny označené odkazy
 */
$('body').simpleCollapse({
	selector: '.js_simple-collapse-by-href',
});

/*********************************************
 * magnify photogallery events
 */
window.activeZoom = null;
require('./eshop-widgets/support-magnify');

/*********************************************
 * model 3D
 */
window.active3DModel = null;
require('./eshop-widgets/support-model3d');

$(function () {
	window.addEventListener('popstate', function (event) {
		if ( event.state && event.state.updatedContainers ) {
			$.get(window.location.url, function (data) {
				var containers = event.state.updatedContainers;
				for ( var i = 0; i < containers.length; i++ ) {
					$(containers[ i ]).html($(data).find(containers[ i ]).html());
				}
			});

			if ( event.state.events && event.state.primaryContainer ) {
				var events = event.state.events;
				for ( var i = 0; i < events.length; i++ ) {
					$(event.state.primaryContainer).trigger(events[ i ]);
				}
			}
		}
	}, false);

	//product filter handler
	$('.js_product-list-filter-container').productListFilter({
		filterFormSelector: '.js_product-list-filter-form',
		containers:         [ '.js_product-list-items-container' ],
	});
	$(document).on('EDEESHOP_PRODUCTLIST_ITEMS_CHANGED', '.js_product-list-container', function () {
		$('.js_product-list-filter-container .js_bootstrap-slider-input').trigger('EDEESHOP_BOOTSTRAP_SLIDER_ACTIVATE');
		$(document).trigger('EDEESHOP_PRODUCT_PAGINATION_ACTIVATE');
	});

	//hadling výběru variant v produktu
	$('.js_product-detail-container').productVariantSelect();
	$(document).on('EDEESHOP_PRODUCTDETAIL_VARIANT_CHANGED', '.js_product-detail-container', function (event) {
		/**
		 * reactivate dhtml number
		 */
		$('.js_dhtml-number', $(event.target)).dhtmlNumber();

		/**
		 * reactivate gallery again
		 */
		$(event.target).trigger('EDEESHOP_PHOTOGALLERY_ACTIVATE');
	});

	// fulltext autocomplete
	$('.js_fulltext-header').fulltextAutocomplete({
		url: `/qf/${ window.projectConfig.lang }/ramjet/fulltextAutocompleteResult`,
	});

	//zobrazeni vice nejprodavanejsich produktu v kategorii
	$('[data-text-toggle]').bestSelledProductsToggle({
		container:    '.js_best-sold-products table',
		defaultCount: 3,
	});

	// input pro počet kusů
	$('.js_dhtml-number').dhtmlNumber();

	/**
	 * DHTML number activation
	 */
	$(document).on('DHTML_NUMBER_CHANGE_PERFORMED', '#orderItemsList input[name^="frm.quantity"]', function (event, data) {
		var timeStamp = new Date();
		var obj = data.input;
		$.partialUpdate.execute(obj.data('actionUrl') + '&quantity=' + obj.val() + '&ts=' + timeStamp.getTime(), obj.data('reloadWidgetId'), function (container, htmlResult) {
			$(container).html(htmlResult);
			$('.js_dhtml-number', $(container)).dhtmlNumber();
			//$(document).trigger("EDEESHOP_BASKET_ITEMS_CHANGED");
		}, { clearCache: true, alterHistory: false });
	});

	/**
	 * partial update after item has been put into shopping cart
	 */
	$(document).on('submit', '.order-form form', function (event, data) {
		event.preventDefault();
		$(document).trigger('FG_UNIVERSAL_PRELOADER_START', 'ADD_ITEM_TO_BASKET');
		$.post($(this).attr('action') + '@pageContainer', $(this).serialize(), function (data) {
			$(document).trigger('FG_UNIVERSAL_PRELOADER_STOP', 'ADD_ITEM_TO_BASKET');
			edeeshopPopup.createPopup(data, 'esp-add-to-cart');
			$(document).trigger('EDEESHOP_BASKET_ITEMS_CHANGED');
		});
	});

	$(document).bind('afterContentsReplaced', function (e, settings) {
		if ( settings && settings.invokedEvent && settings.invokedEvent.currentTarget ) {
			if ( $(settings.invokedEvent.currentTarget).hasClass('removeFromCart') ) {
				$('.js_dhtml-number').dhtmlNumber();
				$(document).trigger('EDEESHOP_BASKET_ITEMS_CHANGED');
			}
		}
	});

	/**
	 * product tools event handlers
	 */
	$(document).on('click', '.js_product-comparison-btn, .js_product-wishlist-btn', function (event, data) {
		event.preventDefault();
		var $t = $(this);

		$(document).trigger('FG_UNIVERSAL_PRELOADER_START', 'ADD_ITEM_TO_COMPARISON');
		$.post($t.attr('data-ajax-href'), function (data) {
			if ( data.ok ) {
				$(document).trigger('FG_UNIVERSAL_PRELOADER_STOP', 'ADD_ITEM_TO_COMPARISON');

				if ( $t.hasClass('js_product-comparison-btn') ) {
					$(document).trigger('EDEESHOP_COMPARISON_ITEMS_CHANGED');
				} else if ( $t.hasClass('js_product-wishlist-btn') ) {
					$(document).trigger('EDEESHOP_WISHLIST_ITEMS_CHANGED');
				}

				if ( $t.hasClass($t.attr('data-active-class')) ) {
					$t.attr('href', $t.attr('href').replace('removeItem', 'addItem'));
					$t.attr('data-ajax-href', $t.attr('data-ajax-href').replace('removeItem', 'addItem'));
				} else {
					$t.attr('href', $t.attr('href').replace('addItem', 'removeItemJson'));
					$t.attr('data-ajax-href', $t.attr('data-ajax-href').replace('addItem', 'removeItem'));
				}
				$t.toggleClass($t.attr('data-active-class'));
			}
		});
	});

	$(document).bind('EDEESHOP_BASKET_ITEMS_CHANGED', function () {
		var timeStamp = new Date();
		$('.js_eshop-header-basket').load('/qf/cs/ramjet/include@userLists?ts=' + timeStamp.getTime() + ' .js_eshop-header-basket > *');
	});

	$(document).bind('EDEESHOP_WISHLIST_ITEMS_CHANGED', function () {
		var timeStamp = new Date();
		$('.js_eshop-header-wishlist').load('/qf/cs/ramjet/include@userLists?ts=' + timeStamp.getTime() + ' .js_eshop-header-wishlist > *');
	});

	$(document).bind('EDEESHOP_COMPARISON_ITEMS_CHANGED', function () {
		var timeStamp = new Date();
		$('.js_eshop-header-comparsion').load('/qf/cs/ramjet/include@userLists?ts=' + timeStamp.getTime() + ' .js_eshop-header-comparsion > *');
	});

	/**
	 * requires jquery.edeeshop-photogallery.js
	 * Edeeshop Photogallery support
	 *		- renders details from thumblist
	 *		- renders control arrows
	 *		- renders zoom (magnify) button if has support
	 *		- renders 3D model button, if has support
	 */

	$(document).on('EDEESHOP_PHOTOGALLERY_ACTIVATE', function (event) {
		$('.js_product-photogallery-activate', $(event.target)).edeeshopPhotogallery({
			magnifyEnabled: true,
			model3DEnabled: true,
		});
	});

	$(document).trigger('EDEESHOP_PHOTOGALLERY_ACTIVATE');

	/**
	 * Bootstrap slider activation
	 */
	$(document).on('EDEESHOP_BOOTSTRAP_SLIDER_ACTIVATE', function (event) {
		var unit = $(event.target).data('unit') || '';
		$(event.target).bootstrapSlider({
			formatter: function formatter(val) {
				if ( Array.isArray(val) ) {
					return val[ 0 ] + ' - ' + val[ 1 ] + ' ' + unit;
				} else {
					return val;
				}
			},
		});
	});

	$('.js_bootstrap-slider-input').trigger('EDEESHOP_BOOTSTRAP_SLIDER_ACTIVATE');

	/********************************************
	 * universal pagination
	 */

	$(document).on('EDEESHOP_PRODUCT_PAGINATION_ACTIVATE', function () {
		$('.js_pagination-products').each(function (index, item) {
			var $pag = $(item);
			$(item).universalPagination({
				listSelector:           '.js_product-list-items-container',
				itemSelector:           '.js_pagination-item-wrapper',
				lang:                   window.projectConfig.lang,
				nextClass:              'btn-next',
				nextWrapperClass:       'btn-next-container',
				autoPreloadHistory:     true,
				listTopOffset:          15,
				paginationSelector:     '.js_pagination-products',
				nextPageButtonSelector: '.js_pagination-next',
			});
		});
	});

	$(document).trigger('EDEESHOP_PRODUCT_PAGINATION_ACTIVATE');
});



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/eshop.js